var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a-swap",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_69118",
    "data-name": "Path 69118",
    d: "M-102.22,123.713h0l-27.5,54h10.994l16.506-32.87h0l16.506,32.87H-74.72Z",
    transform: "translate(129.72 -123.713)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69119",
    "data-name": "Path 69119",
    d: "M-68.043,214.236c-5.944,3.443-14.014,3.111-16.744-3.273,3.239,2.9,6.107,2.454,9.241.591C-73.121,210.112-70.492,211.24-68.043,214.236Z",
    transform: "translate(104.395 -172.696)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAswap);
export default __webpack_public_path__ + "static/media/aswap.f4bffae2a21b7f977f4aed3e3dd595d9.svg";
export { ForwardRef as ReactComponent };